import {
    differenceInCalendarDays,
    format,
    isSameDay,
    isSameYear,
} from "date-fns";
import { fullDateFullYearFormat } from "@common/helpers/date";

export function lastActivityLabel(activity: Date) {
    const now = new Date();

    if (isSameDay(activity, now)) {
        return "Today";
    } else if (differenceInCalendarDays(now, activity) === 1) {
        return "Yesterday";
    } else if (isSameYear(activity, now)) {
        return format(activity, fullDateFullYearFormat);
    } else {
        return format(activity, fullDateFullYearFormat);
    }
}
